import { applyPageSeo } from './seo';
import { withBase } from './base';

/**
 * 학교급식 조리용 / 후식용 탭
 * - 페이지 리마운트 없이 패널만 전환
 * - URL path는 replaceState로 동기화
 * - 탭 클릭 시 '학교급식은 조리…' 리드 텍스트로 스크롤
 */
export type SchoolTab = 'cooking' | 'snack';

const TAB_PATH: Record<SchoolTab, string> = {
  cooking: '/school',
  snack: '/school/snack',
};

export function setSchoolTab(root: ParentNode, tab: SchoolTab) {
  const tabs = root.querySelectorAll<HTMLElement>('[data-school-tab]');
  const panels = root.querySelectorAll<HTMLElement>('[data-school-panel]');
  const leads = root.querySelectorAll<HTMLElement>('[data-school-lead]');

  tabs.forEach((el) => {
    const active = el.dataset.schoolTab === tab;
    el.classList.toggle('is-active', active);
    el.setAttribute('aria-selected', String(active));
  });

  panels.forEach((panel) => {
    panel.hidden = panel.dataset.schoolPanel !== tab;
  });

  leads.forEach((lead) => {
    const active = lead.dataset.schoolLead === tab;
    lead.hidden = !active;
    if (active) lead.id = 'school-lead';
    else lead.removeAttribute('id');
  });

  applyPageSeo(tab === 'snack' ? 'schoolSnack' : 'school');

  const nextPath = withBase(TAB_PATH[tab]);
  if (window.location.pathname !== nextPath) {
    history.replaceState(null, '', nextPath);
  }
}

/** 헤더 높이를 감안해 리드 텍스트로 스크롤 */
export function scrollToSchoolLead(root: ParentNode) {
  const lead = root.querySelector<HTMLElement>('#school-lead');
  if (!lead) return;

  const header = document.querySelector<HTMLElement>('[data-header]');
  const headerH = header?.getBoundingClientRect().height ?? 100;
  const top = lead.getBoundingClientRect().top + window.scrollY - headerH - 12;

  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

export function initSchoolTabs(root: ParentNode, initial: SchoolTab): () => void {
  setSchoolTab(root, initial);

  const onClick = (event: Event) => {
    const target = (event.target as Element | null)?.closest<HTMLElement>('[data-school-tab]');
    if (!target || !root.contains(target)) return;

    const tab = target.dataset.schoolTab;
    if (tab !== 'cooking' && tab !== 'snack') return;

    event.preventDefault();
    setSchoolTab(root, tab);
    scrollToSchoolLead(root);
  };

  root.addEventListener('click', onClick);
  return () => root.removeEventListener('click', onClick);
}
